<template>
  <div>
    <va-card class="mb-4">
      <div class="d-flex justify--space-between">
        <h1>Промокоды</h1>
        <va-button color="info" @click="openCreateModal">
          Добавить промокод
        </va-button>
      </div>
    </va-card>
    <promocode-table
      :promocodes="promocodes"
      @needFetchPromocodes="fetchPromocodes"
      @openUpdateForm="promocodeUpdateInfo"
    ></promocode-table>
    <va-modal v-model="showCreateForm" size="large" hide-default-actions>
      <promocode-create
        @close="showCreateForm = false"
        @needFetchPromocodes="fetchPromocodes"
      ></promocode-create>
    </va-modal>
    <va-modal v-model="showUpdateForm" size="large" hide-default-actions>
      <promocode-update
        @close="showUpdateForm = false"
        :promocode-info="promocodesInfo"
        @needFetchPromocodes="fetchPromocodes"
      ></promocode-update>
    </va-modal>
  </div>
</template>

<script>
import api from "@/api/axios";
import promocodeTable from "@/components/promocodes/promocode-table.vue";
import PromocodeCreate from "../../components/promocodes/promocode-create.vue";
import PromocodeUpdate from "../../components/promocodes/promocode-update.vue";
export default {
  components: { promocodeTable, PromocodeCreate, PromocodeUpdate },
  name: "promocodes",
  data() {
    return {
      promocodes: [],
      showCreateForm: false,
      showUpdateForm: false,
      promocodesInfo: null,
    };
  },
  created() {
    this.fetchPromocodes();
  },
  methods: {
    async fetchPromocodes() {
      try {
        const res = await api.get("admin/promocodes", {
          params: {
            all: 1,
          },
        });
        this.promocodes = res.data.data;
      } catch (error) {
        return error;
      }
    },
    promocodeUpdateInfo(val) {
      this.showUpdateForm = true;
      this.promocodesInfo = val;
    },
    openCreateModal() {
      this.showCreateForm = true;
    },
  },
};
</script>

<style>
</style>